import { db } from './firebaseConfig';
import { collection, addDoc } from "firebase/firestore";

const AgregarEmpresaDb = async ({
    rut,
    empresa,
    userAdd,
    userMod,
    fechaAdd,
    fechaMod,
    logoUrl = "",
    logoPath = "",
    versionLogo = 1,
    estado = "ACTIVA",
    plan = "BASICO",
    maxUsers = 5,
}) => {

    const docRef = await addDoc(collection(db, 'empresas'), {
        rut: rut,
        empresa: empresa,

        // 🔹 NUEVOS CAMPOS
        logoUrl,
        logoPath,
        versionLogo,
        estado,
        plan,
        maxUsers,

        // 🔹 EXISTENTES
        useradd: userAdd,
        usermod: userMod,
        fechaadd: fechaAdd,
        fechamod: fechaMod
    });

    return docRef.id; // 🔥 CLAVE
};

export default AgregarEmpresaDb;